import React from 'react'
import Link from 'next/link'

import styled from '@emotion/styled'

const OtaButton = ({ name, link }) => {
  return (
    <Contianer>
      <Link href={link} target="_blank">
        {name}
      </Link>
    </Contianer>
  )
}

export default OtaButton

const Contianer = styled.div`
  width: 50%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #ddd;

  a {
    font-weight: 700;
    color: #333;
    width: 100%;
    display: inline-block;
  }
`
